module.exports = __webpack_public_path__ + "static/media/webscape_24_winner.b0bb3341.jpg";